"use client";

import { useLayoutEffect, useRef } from "react";

import { BlogLayoutProps } from "@/types";
import { CardTitle } from "../ui/card";
import RecentPostsPreviews from "../RecentPostPreviews";
import { Separator } from "../ui/separator";
import WPPostRender from "../WPPostRender";
import { useDataContext } from "@/app/_context";

export default function BlogLayout({
  posts,
  post,
  recentPostPreviews,
  recentPostPreviewsFirst,
}: BlogLayoutProps) {
  const { setScrollPositionY } = useDataContext();
  const mainContainerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const container = mainContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      setScrollPositionY(container.scrollTop);
    };

    handleScroll();
    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [setScrollPositionY]);

  if (post || posts)
    return (
      <div
        ref={mainContainerRef}
        className="relative h-full w-full overflow-y-auto overflow-x-clip mx-auto scroll-smooth"
      >
        <div
          id="blog-top"
          className="w-full absolute top-0 left-0 mx-auto"
        >
          {/* <BlogHeader /> */}
          <div className="dark:bg-black/50 border border-transparent pb-20">
            <div className="max-w-7xl mx-auto px-4 md:px-8">
              {post ? (
                <div>
                  <WPPostRender index={1} post={post} />
                  <div className="md:py-6 gap-6 flex flex-col">
                    <Separator className="dark:bg-white !bg-gray-500" />

                    <CardTitle>Recent Posts:</CardTitle>
                  </div>

                  {!recentPostPreviewsFirst && (
                    <RecentPostsPreviews recentPosts={recentPostPreviews} />
                  )}
                </div>
              ) : (
                <div>
                  {!recentPostPreviewsFirst && (
                    <RecentPostsPreviews
                      recentPosts={recentPostPreviews}
                      main
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
}
